import { useState } from 'react';
import { useClerk } from '@clerk/clerk-react';
import { LogOut, User } from 'lucide-react';
import { posthog } from 'posthog-js';
import { UserProfileModal } from 'src/components/SidebarDropdown/UserProfileModal';

import { useNavigate } from 'components/Nav';

import classes from './style.module.css';

type UserMenuButtonProps = {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
};

const UserMenuButton = ({ icon, label, onClick }: UserMenuButtonProps) => (
  <button type="button" className={classes.menuButton} onClick={onClick}>
    {icon}
    <span>{label}</span>
  </button>
);

export const UserMenu = () => {
  const [userProfileOpen, setUserProfileOpen] = useState(false);
  const { signOut } = useClerk();
  const navigate = useNavigate();

  const handleSignOut = () => {
    posthog.reset();
    signOut();
    navigate('/sign-in');
  };

  return (
    <>
      <div className={classes.userMenu}>
        <UserMenuButton
          icon={<User size={20} />}
          label="Profile"
          onClick={() => setUserProfileOpen(true)}
        />
        <UserMenuButton
          icon={<LogOut size={20} />}
          label="Sign out"
          onClick={handleSignOut}
        />
      </div>
      {userProfileOpen && <UserProfileModal setUserProfileOpen={setUserProfileOpen} />}
    </>
  );
};
